<h3 class="text-center" style="color: #5A1727">Baja</h3>
<mat-horizontal-stepper linear #stepper>
  <mat-step [stepControl]="(datosCliente | async)" [editable]="isEditable">
    <ng-template matStepLabel>Cliente</ng-template>
    <app-cliente #clienteComponent (datoCliente)="siguiente2($event)"></app-cliente>
  </mat-step>

  <mat-step [stepControl]="datosVehiculos" [editable]="isEditable">
    <ng-template matStepLabel>Vehículo</ng-template>
    <form [formGroup]="datosVehiculos" autocomplete="off" (ngSubmit)="siguiente()">
      <h3 class="text-left" style="color: #5A1727">Datos Básicos</h3>
      <hr>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Matrícula(A)</mat-label>
        <input matInput matNativeControl type="text" maxlength="10" [class.is-invalid]="matriculaNoValido" formControlName="matricula" (input)="getVehiculo()">
        <small *ngIf="matriculaNoValido">
          La matrícula es <strong>requerido</strong>
        </small>
      </mat-form-field>
      <div class="input-group">
        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
          <mat-label>Nº Bastidor (E)</mat-label>
          <input matInput matNativeControl type="text" maxlength="30" [class.is-invalid]="bastidorNoValido"
                formControlName="bastidor" onkeydown="return /[A-HJ-NPR-Za-hj-npr-z\d]/i.test(event.key)" maxlength="17">
          <small *ngIf="bastidorNoValido">
            El numero de Bastidor es <strong>requerido</strong>
          </small>
        </mat-form-field>
        <div class="input-group-btn">
          <button mat-button  class="btn btn-secondary" style="vertical-align: middle; margin-top: 6px" (click)="getDatosEITV()" matTooltip="Presione para recuperar los datos del vehículo desde la DGT">
            Recuperar datos técnicos <mat-icon>directions_car</mat-icon>
          </button>
        </div>
      </div>
      <!--
      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Nº Bastidor(E)</mat-label>
        <input matInput matNativeControl type="text" [class.is-invalid]="bastidorNoValido"
               formControlName="bastidor" onkeydown="return /[A-HJ-NPR-Za-hj-npr-z\d]/i.test(event.key)" maxlength="17">
        <small *ngIf="bastidorNoValido">
          El numero de Bastidor es <strong>requerido</strong>
        </small>
      </mat-form-field>
      -->

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Marca(D.1)</mat-label>
        <input matInput matNativeControl type="text" maxlength="45" [class.is-invalid]="marcaNoValido" formControlName="marca">
        <small *ngIf="marcaNoValido">
          La marca es <strong>requerida</strong>
        </small>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Modelo(D.3)</mat-label>
        <input matInput matNativeControl type="text" maxlength="50" [class.is-invalid]="modeloNoValido" formControlName="modelo">
        <small *ngIf="modeloNoValido">
          El modelo es <strong>requerido</strong>
        </small>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
        <mat-label>Clasificación</mat-label>
        <select matInput matNativeControl formControlName="tipoVehiculo">
          <option label="--Seleccionar--"></option>
          <option value="03">03xx – CICLOMOTOR</option>
          <option value="04">04xx – MOTOCICLETA</option>
          <option value="06">06xx – AUTOMÓVIL DE TRES RUEDAS</option>
          <option value="10">10xx – TURISMO</option>
          <option value="17">17xx – PICK UP</option>
          <option value="20">20xx – CAMIÓN MMA ≤3.500 kg</option>
          <option value="21">21xx – CAMIÓN 3.500 kg. < MMA ≤ 12.500 kg</option>
          <option value="22">22xx – CAMIÓN MMA > 12.000 kg</option>
          <option value="24">24xx – FURGÓN/FURGONETA MMA ≤ 3.500 kg</option>
          <option value="31">31xx – VEHICULO MIXTO ADAPTABLE</option>
          <option value="32">32xx – AUTO-CARAVANA MMA ≤ 3.500 kg</option>
          <option value="33">33xx – AUTO-CARAVANA MMA > 3.500 kg</option>
          <option value="66">66xx – QUAD ATV</option>
        </select>
      </mat-form-field>


      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Fecha Matriculación(I)</mat-label>
        <input matInput [matDatepicker]="picker" placeholder="{{hoy.toLocaleDateString()}}" formControlName="fechaMatriculacion">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Cilindrada(P.1)</mat-label>
        <input matInput matNativeControl type="text" maxlength="6" formControlName="cilindrada">
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Potencia Fiscal(P.2.1)</mat-label>
        <input matInput matNativeControl type="text" maxlength="50" formControlName="potenciaFiscal">
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>CV(P.2)</mat-label>
        <input matInput matNativeControl type="text" maxlength="10" formControlName="cv">
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>CO2(V.7)</mat-label>
        <input matInput matNativeControl type="number" maxlength="25" formControlName="co2">
      </mat-form-field>

      <div class="row mt-2">
        <div class="col-6 text-right">
          <button mat-button class="btn-danger" matStepperPrevious>Atras</button>
        </div>

        <div class="col-6 text-left">
          <button mat-button type="submit" class="btn-info" matStepperNext>Siguiente</button>
        </div>
      </div>

    </form>
  </mat-step>

  <mat-step [stepControl]="documentos" [editable]="isEditable">
    <ng-template matStepLabel>Documentos</ng-template>
    <h3 class="text-left" style="color: #5A1727">Documentos</h3>
    <h3  style="color: #5A1727"  *ngIf="sumFileSize <= maxSum" >{{formatBytes(sumFileSize)}}/{{formatBytes(maxSum)}}</h3>
    <h3  *ngIf="sumFileSize> maxSum"  style="color: #f60000">{{formatBytes(sumFileSize)}}/{{formatBytes(maxSum)}} - Tamaño total excedido</h3>
    <hr>
    <div class="row">
      <!--0 - DNI Comprador-->
      <div class="col-lg-4 col-md-6 col-sm-12" style="margin-top: 0.5em">
        <div class="contenedor">
          <div class="title">
            <label class="text-white">DNI Comprador</label>
          </div>
          <div class="container" appDragDrog (fileDropped)="onFileDropped($event, 0)">
            <input class="input" type="file" id="fileDropRef" accept="image/* , application/pdf"
                   multiple (change)="fileBrowseHandler($event.target.files, 0)"/>
            <img src="assets/img/subir.svg" width="63" height="30" alt="">
            <h3 class="h3">Arrastra y suelta el archivo aquí o buscar archivo.. </h3>
          </div>
        </div>
        <div class="files-list">
          <div class="single-file" *ngFor="let file of filesDniComprador; let i = index">
            <img src="assets/img/archivo.svg" width="45px" alt="file">
            <div class="info">
              <h4 class="name">
                {{ file?.name }}
              </h4>
              <p class="size">
                {{ formatBytes(file?.size) }}
              </p>
              <app-progress [progress]="file?.progress"></app-progress>
            </div>
            <img src="assets/img/delete.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i, 0)">
          </div>
        </div>
      </div>
      <!--1 - DNI Vendedor-->
      <div class="col-lg-4 col-md-6 col-sm-12" style="margin-top: 0.5em">
        <div class="contenedor">
          <div class="title">
            <label class="text-white">DNI Vendedor</label>
          </div>
          <div class="container" appDragDrog (fileDropped)="onFileDropped($event, 1)">
            <input class="input" type="file" id="fileDropRef32" accept="image/* , application/pdf"
                   multiple (change)="fileBrowseHandler($event.target.files, 1)"/>
            <img src="assets/img/subir.svg" width="63" height="30" alt="">
            <h3 class="h3">Arrastra y suelta el archivo aquí o buscar archivo.. </h3>
          </div>
        </div>
        <div class="files-list">
          <div class="single-file" *ngFor="let file of filesDniVendedor; let i = index">
            <img src="assets/img/archivo.svg" width="45px" alt="file">
            <div class="info">
              <h4 class="name">
                {{ file?.name }}
              </h4>
              <p class="size">
                {{ formatBytes(file?.size) }}
              </p>
              <app-progress [progress]="file?.progress"></app-progress>
            </div>
            <img src="assets/img/delete.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i, 1)">
          </div>
        </div>
      </div>
      <!--2 - Mandato Compradpr-->
      <div class="col-lg-4 col-md-6 col-sm-12" style="margin-top: 0.5em">
        <div class="contenedor">
          <div class="title">
            <label class="text-white">Mandato Comprador</label>
          </div>
          <div class="container" appDragDrog (fileDropped)="onFileDropped($event, 2)">
            <input class="input" type="file" id="filDropRef" accept="image/* , application/pdf"
                   multiple (change)="fileBrowseHandler($event.target.files, 2)"/>
            <img src="assets/img/subir.svg" width="63" height="30" alt="">
            <h3 class="h3">Arrastra y suelta el archivo aquí o buscar archivo.. </h3>
          </div>
        </div>
        <div class="files-list">
          <div class="single-file" *ngFor="let file of fileMandatoComprador; let i = index">
            <img src="assets/img/archivo.svg" width="45px" alt="file">
            <div class="info">
              <h4 class="name">
                {{ file?.name }}
              </h4>
              <p class="size">
                {{ formatBytes(file?.size) }}
              </p>
              <app-progress [progress]="file?.progress"></app-progress>
            </div>
            <img src="assets/img/delete.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i, 2)">
          </div>
        </div>
      </div>
      <!--3 - Mandato Vendedor-->
      <div class="col-lg-4 col-md-6 col-sm-12" style="margin-top: 0.5em">
        <div class="contenedor">
          <div class="title">
            <label class="text-white">Mandato Vendedor</label>
          </div>
          <div class="container" appDragDrog (fileDropped)="onFileDropped($event, 3)">
            <input class="input" type="file" id="filDropRef001" accept="image/* , application/pdf"
                   multiple (change)="fileBrowseHandler($event.target.files, 3)"/>
            <img src="assets/img/subir.svg" width="63" height="30" alt="">
            <h3 class="h3">Arrastra y suelta el archivo aquí o buscar archivo.. </h3>
          </div>
        </div>
        <div class="files-list">
          <div class="single-file" *ngFor="let file of fileMandatoVendedor; let i = index">
            <img src="assets/img/archivo.svg" width="45px" alt="file">
            <div class="info">
              <h4 class="name">
                {{ file?.name }}
              </h4>
              <p class="size">
                {{ formatBytes(file?.size) }}
              </p>
              <app-progress [progress]="file?.progress"></app-progress>
            </div>
            <img src="assets/img/delete.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i, 3)">
          </div>
        </div>
      </div>
      <!--4 - CIF Comprador-->
      <div class="col-lg-4 col-md-6 col-sm-12" style="margin-top: 0.5em">
        <div class="contenedor">
          <div class="title">
            <label class="text-white">CIF Comprador</label>
          </div>
          <div class="container" appDragDrog (fileDropped)="onFileDropped($event, 4)">
            <input class="input" type="file" id="fileDropRefrs" accept="image/* , application/pdf"
                   multiple (change)="fileBrowseHandler($event.target.files, 4)"/>
            <img src="assets/img/subir.svg" width="63" height="30" alt="">
            <h3 class="h3">Arrastra y suelta el archivo aquí o buscar archivo.. </h3>
          </div>
        </div>
        <div class="files-list">
          <div class="single-file" *ngFor="let file of filesCIFComprador; let i = index">
            <img src="assets/img/archivo.svg" width="45px" alt="file">
            <div class="info">
              <h4 class="name">
                {{ file?.name }}
              </h4>
              <p class="size">
                {{ formatBytes(file?.size) }}
              </p>
              <app-progress [progress]="file?.progress"></app-progress>
            </div>
            <img src="assets/img/delete.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i, 4)">
          </div>
        </div>
      </div>
      <!--5 - CIF Vendedor-->
      <div class="col-lg-4 col-md-6 col-sm-12" style="margin-top: 0.5em">
        <div class="contenedor">
          <div class="title">
            <label class="text-white">CIF Vendedor</label>
          </div>
          <div class="container" appDragDrog (fileDropped)="onFileDropped($event, 5)">
            <input class="input" type="file" id="fileDropRefrs12" accept="image/* , application/pdf"
                   multiple (change)="fileBrowseHandler($event.target.files, 5)"/>
            <img src="assets/img/subir.svg" width="63" height="30" alt="">
            <h3 class="h3">Arrastra y suelta el archivo aquí o buscar archivo.. </h3>
          </div>
        </div>
        <div class="files-list">
          <div class="single-file" *ngFor="let file of filesCIFVendedor; let i = index">
            <img src="assets/img/archivo.svg" width="45px" alt="file">
            <div class="info">
              <h4 class="name">
                {{ file?.name }}
              </h4>
              <p class="size">
                {{ formatBytes(file?.size) }}
              </p>
              <app-progress [progress]="file?.progress"></app-progress>
            </div>
            <img src="assets/img/delete.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i, 5)">
          </div>
        </div>
      </div>
      <!--6 - PODER-->
      <div class="col-lg-4 col-md-6 col-sm-12" style="margin-top: 0.5em">
        <div class="contenedor">
          <div class="title">
            <label class="text-white">Poder(Empresa)</label>
          </div>
          <div class="container" appDragDrog (fileDropped)="onFileDropped($event, 6)">
            <input class="input" type="file" id="fileDropRefe" accept="image/* , application/pdf"
                   multiple (change)="fileBrowseHandler($event.target.files, 6)"/>
            <img src="assets/img/subir.svg" width="63" height="30" alt="">
            <h3 class="h3">Arrastra y suelta el archivo aquí o buscar archivo.. </h3>
          </div>
        </div>
        <div class="files-list">
          <div class="single-file" *ngFor="let file of filesPoder; let i = index">
            <img src="assets/img/archivo.svg" width="45px" alt="file">
            <div class="info">
              <h4 class="name">
                {{ file?.name }}
              </h4>
              <p class="size">
                {{ formatBytes(file?.size) }}
              </p>
              <app-progress [progress]="file?.progress"></app-progress>
            </div>
            <img src="assets/img/delete.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i, 6)">
          </div>
        </div>
      </div>
      <!--7 - FACTURA VENTA-->
      <div class="col-lg-4 col-md-6 col-sm-12" style="margin-top: 0.5em">
        <div class="contenedor">
          <div class="title">
            <label class="text-white">Factura/ Contrato CompraVenta</label>
          </div>
          <div class="container" appDragDrog (fileDropped)="onFileDropped($event, 7)">
            <input class="input" type="file" id="fiDropRefs" accept="image/* , application/pdf"
                   multiple (change)="fileBrowseHandler($event.target.files, 7)"/>
            <img src="assets/img/subir.svg" width="63" height="30" alt="">
            <h3 class="h3">Arrastra y suelta el archivo aquí o buscar archivo.. </h3>
          </div>

        </div>
        <div class="files-list">
          <div class="single-file" *ngFor="let file of fileFactura; let i = index">
            <img src="assets/img/archivo.svg" width="45px" alt="file">
            <div class="info">
              <h4 class="name">
                {{ file?.name }}
              </h4>
              <p class="size">
                {{ formatBytes(file?.size) }}
              </p>
              <app-progress [progress]="file?.progress"></app-progress>
            </div>
            <img src="assets/img/delete.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i, 7)">
          </div>
        </div>
      </div>
      <!--8 - FICHA TECNICA-->
      <div class="col-lg-4 col-md-6 col-sm-12" style="margin-top: 0.5em">
        <div class="contenedor">
          <div class="title">
            <label class="text-white">Ficha Técnica</label>
          </div>
          <div class="container" appDragDrog (fileDropped)="onFileDropped($event, 8)">
            <input class="input" type="file" id="fiDropRefe" accept="image/* , application/pdf"
                   multiple (change)="fileBrowseHandler($event.target.files, 8)"/>
            <img src="assets/img/subir.svg" width="63" height="30" alt="">
            <h3 class="h3">Arrastra y suelta el archivo aquí o buscar archivo.. </h3>
          </div>
        </div>
        <div class="files-list">
          <div class="single-file" *ngFor="let file of fileFicha; let i = index">
            <img src="assets/img/archivo.svg" width="45px" alt="file">
            <div class="info">
              <h4 class="name">
                {{ file?.name }}
              </h4>
              <p class="size">
                {{ formatBytes(file?.size) }}
              </p>
              <app-progress [progress]="file?.progress"></app-progress>
            </div>
            <img src="assets/img/delete.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i, 8)">
          </div>
        </div>
      </div>
      <!--9 - PERMISO-->
      <div class="col-lg-4 col-md-6 col-sm-12" style="margin-top: 0.5em">
        <div class="contenedor">
          <div class="title">
            <label class="text-white">Permiso de Circulación</label>
          </div>
          <div class="container" appDragDrog (fileDropped)="onFileDropped($event, 9)">
            <input class="input" type="file" id="fDropRefrs" accept="image/* , application/pdf"
                   multiple (change)="fileBrowseHandler($event.target.files, 9)"/>
            <img src="assets/img/subir.svg" width="63" height="30" alt="">
            <h3 class="h3">Arrastra y suelta el archivo aquí o buscar archivo.. </h3>
          </div>
        </div>
        <div class="files-list">
          <div class="single-file" *ngFor="let file of filePermiso; let i = index">
            <img src="assets/img/archivo.svg" width="45px" alt="file">
            <div class="info">
              <h4 class="name">
                {{ file?.name }}
              </h4>
              <p class="size">
                {{ formatBytes(file?.size) }}
              </p>
              <app-progress [progress]="file?.progress"></app-progress>
            </div>
            <img src="assets/img/delete.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i, 9)">
          </div>
        </div>
      </div>
      <!--10 - PADRON-->
      <div class="col-lg-4 col-md-6 col-sm-12" style="margin-top: 0.5em">
        <div class="contenedor">
          <div class="title">
            <label class="text-white">Padrón/ Justificante de Domicilio</label>
          </div>
          <div class="container" appDragDrog (fileDropped)="onFileDropped($event, 10)">
            <input class="input" type="file" id="fDropRef" accept="image/* , application/pdf"
                   multiple (change)="fileBrowseHandler($event.target.files, 10)"/>
            <img src="assets/img/subir.svg" width="63" height="30" alt="">
            <h3 class="h3">Arrastra y suelta el archivo aquí o buscar archivo.. </h3>
          </div>
        </div>
        <div class="files-list">
          <div class="single-file" *ngFor="let file of filesPadron; let i = index">
            <img src="assets/img/archivo.svg" width="45px" alt="file">
            <div class="info">
              <h4 class="name">
                {{ file?.name }}
              </h4>
              <p class="size">
                {{ formatBytes(file?.size) }}
              </p>
              <app-progress [progress]="file?.progress"></app-progress>
            </div>
            <img src="assets/img/delete.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i, 10)">
          </div>
        </div>
      </div>
      <!--11 - NRC-->
      <div class="col-lg-4 col-md-6 col-sm-12" style="margin-top: 0.5em">
        <div class="contenedor">
          <div class="title">
            <label class="text-white">576/ NRC</label>
          </div>
          <div class="container" appDragDrog (fileDropped)="onFileDropped($event, 11)">
            <input class="input" type="file" id="fDropRefs" accept="image/* , application/pdf"
                   multiple (change)="fileBrowseHandler($event.target.files, 11)"/>
            <img src="assets/img/subir.svg" width="63" height="30" alt="">
            <h3 class="h3">Arrastra y suelta el archivo aquí o buscar archivo.. </h3>
          </div>
        </div>
        <div class="files-list">
          <div class="single-file" *ngFor="let file of filesNRC; let i = index">
            <img src="assets/img/archivo.svg" width="45px" alt="file">
            <div class="info">
              <h4 class="name">
                {{ file?.name }}
              </h4>
              <p class="size">
                {{ formatBytes(file?.size) }}
              </p>
              <app-progress [progress]="file?.progress"></app-progress>
            </div>
            <img src="assets/img/delete.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i, 11)">
          </div>
        </div>
      </div>
      <!--12 - 05-->
      <div class="col-lg-4 col-md-6 col-sm-12" style="margin-top: 0.5em">
        <div class="contenedor">
          <div class="title">
            <label class="text-white">Documentos 05</label>
          </div>
          <div class="container" appDragDrog (fileDropped)="onFileDropped($event, 12)">
            <input class="input" type="file" id="filDropRefs34" accept="image/* , application/pdf"
                   multiple (change)="fileBrowseHandler($event.target.files, 12)"/>
            <img src="assets/img/subir.svg" width="63" height="30" alt="">
            <h3 class="h3">Arrastra y suelta el archivo aquí o buscar archivo.. </h3>
          </div>
        </div>
        <div class="files-list">
          <div class="single-file" *ngFor="let file of file05; let i = index">
            <img src="assets/img/archivo.svg" width="45px" alt="file">
            <div class="info">
              <h4 class="name">
                {{ file?.name }}
              </h4>
              <p class="size">
                {{ formatBytes(file?.size) }}
              </p>
              <app-progress [progress]="file?.progress"></app-progress>
            </div>
            <img src="assets/img/delete.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i, 12)">
          </div>
        </div>
      </div>
      <!--13 - 06-->
      <div class="col-lg-4 col-md-6 col-sm-12" style="margin-top: 0.5em">
        <div class="contenedor">
          <div class="title">
            <label class="text-white">Documentos 06</label>
          </div>
          <div class="container" appDragDrog (fileDropped)="onFileDropped($event, 13)">
            <input class="input" type="file" id="filDropRefs" accept="image/* , application/pdf"
                   multiple (change)="fileBrowseHandler($event.target.files, 13)"/>
            <img src="assets/img/subir.svg" width="63" height="30" alt="">
            <h3 class="h3">Arrastra y suelta el archivo aquí o buscar archivo.. </h3>
          </div>
        </div>
        <div class="files-list">
          <div class="single-file" *ngFor="let file of file06; let i = index">
            <img src="assets/img/archivo.svg" width="45px" alt="file">
            <div class="info">
              <h4 class="name">
                {{ file?.name }}
              </h4>
              <p class="size">
                {{ formatBytes(file?.size) }}
              </p>
              <app-progress [progress]="file?.progress"></app-progress>
            </div>
            <img src="assets/img/delete.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i, 13)">
          </div>
        </div>
      </div>
      <!--14 - IVA 4%-->
      <div class="col-lg-4 col-md-6 col-sm-12" style="margin-top: 0.5em">
        <div class="contenedor">
          <div class="title">
            <label class="text-white">Documentos IVA 4%</label>
          </div>
          <div class="container" appDragDrog (fileDropped)="onFileDropped($event, 14)">
            <input class="input" type="file" id="fileDropRefs" accept="image/* , application/pdf"
                   multiple (change)="fileBrowseHandler($event.target.files, 14)"/>
            <img src="assets/img/subir.svg" width="63" height="30" alt="">
            <h3 class="h3">Arrastra y suelta el archivo aquí o buscar archivo.. </h3>
          </div>
        </div>
        <div class="files-list">
          <div class="single-file" *ngFor="let file of fileIva4; let i = index">
            <img src="assets/img/archivo.svg" width="45px" alt="file">
            <div class="info" >
              <h4 class="name">
                {{ file?.name }}
              </h4>
              <p class="size">
                {{ formatBytes(file?.size) }}
              </p>
              <app-progress [progress]="file?.progress"></app-progress>
            </div>
            <img src="assets/img/delete.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i, 14)">
          </div>
        </div>
      </div>
      <!--15 - OTROS-->
      <div class="col-lg-4 col-md-6 col-sm-12" style="margin-top: 0.5em">
        <div class="contenedor">
          <div class="title">
            <label class="text-white">Otros Documentos</label>
          </div>
          <div class="container" appDragDrog (fileDropped)="onFileDropped($event, 15)">
            <input class="input" type="file" id="fileDropRefr" accept="image/* , application/pdf"
                   multiple (change)="fileBrowseHandler($event.target.files, 15)"/>
            <img src="assets/img/subir.svg" width="63" height="30" alt="">
            <h3 class="h3">Arrastra y suelta el archivo aquí o buscar archivo.. </h3>
          </div>
        </div>
        <div class="files-list">
          <div class="single-file" *ngFor="let file of fileOtros; let i = index">
            <img src="assets/img/archivo.svg" width="45px" alt="file">
            <div class="info">
              <h4 class="name">
                {{ file?.name }}
              </h4>
              <p class="size">
                {{ formatBytes(file?.size) }}
              </p>
              <app-progress [progress]="file?.progress"></app-progress>
            </div>
            <img src="assets/img/delete.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i, 15)">
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-5" style="margin-bottom: 20px">
      <div class="col-4 text-right">
        <button mat-button class="btn-danger" matStepperPrevious>Atras</button>
      </div>
      <div class="col-4 text-center">
        <button mat-button class="btn-secondary" (click)="stepper.reset()">Restablecer</button>
      </div>
      <div class="col-4 text-left">
        <button mat-button class="btn-info" (click)="guardar()">Guardar</button>
      </div>
    </div>

  </mat-step>
</mat-horizontal-stepper>
<div *ngIf="spinnerEITV" class="spinner swal2-container swal2-center swal2-backdrop-show">
  <img class="spinner-img" alt="" src="../../../assets/img/logo-empresa.png">
  <h4  style="margin-top: 200px; color: white">Conectando con la DGT...</h4>
</div>
